export function isWechatAgent() {
  return navigator.userAgent.toLowerCase().includes('micromessenger')
}

export function isUatHost() {
  return window.location.hostname.includes('-uat')
}
